module.exports = __webpack_public_path__ + "static/media/toko1_ORIGINAL.askdlaskda.8287636a.png";